/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseAmountRespVo } from './DeliverFeeWarehouseAmountRespVo';
import {
    DeliverFeeWarehouseAmountRespVoFromJSON,
    DeliverFeeWarehouseAmountRespVoFromJSONTyped,
    DeliverFeeWarehouseAmountRespVoToJSON,
    DeliverFeeWarehouseAmountRespVoToJSONTyped,
} from './DeliverFeeWarehouseAmountRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationKrFeeGradeFeeRespVo
 */
export interface DeliveryCalculationKrFeeGradeFeeRespVo {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof DeliveryCalculationKrFeeGradeFeeRespVo
     */
    gradeId?: number;
    /**
     * 明细渲染模式：RANGE 区间明细
     * @type {string}
     * @memberof DeliveryCalculationKrFeeGradeFeeRespVo
     */
    ruleMode?: string;
    /**
     * 区间-金额明细
     * @type {Array<DeliverFeeWarehouseAmountRespVo>}
     * @memberof DeliveryCalculationKrFeeGradeFeeRespVo
     */
    ranges?: Array<DeliverFeeWarehouseAmountRespVo>;
}

/**
 * Check if a given object implements the DeliveryCalculationKrFeeGradeFeeRespVo interface.
 */
export function instanceOfDeliveryCalculationKrFeeGradeFeeRespVo(value: object): value is DeliveryCalculationKrFeeGradeFeeRespVo {
    return true;
}

export function DeliveryCalculationKrFeeGradeFeeRespVoFromJSON(json: any): DeliveryCalculationKrFeeGradeFeeRespVo {
    return DeliveryCalculationKrFeeGradeFeeRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationKrFeeGradeFeeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationKrFeeGradeFeeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'ruleMode': json['ruleMode'] == null ? undefined : json['ruleMode'],
        'ranges': json['ranges'] == null ? undefined : ((json['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoFromJSON)),
    };
}

export function DeliveryCalculationKrFeeGradeFeeRespVoToJSON(json: any): DeliveryCalculationKrFeeGradeFeeRespVo {
    return DeliveryCalculationKrFeeGradeFeeRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationKrFeeGradeFeeRespVoToJSONTyped(value?: DeliveryCalculationKrFeeGradeFeeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'ruleMode': value['ruleMode'],
        'ranges': value['ranges'] == null ? undefined : ((value['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoToJSON)),
    };
}

